/**
 * @fileoverview Utility functions for formatting data
 */
import { format } from 'date-fns';
/**
 * Formats a date string to a readable format
 */
export const formatDate = (dateString) => {
    if (!dateString)
        return 'Hoy';
    try {
        const date = new Date(dateString);
        return format(date, 'dd/MM/yyyy');
    }
    catch {
        return dateString;
    }
};
/**
 * Formats a wallet address to show first 6 and last 4 characters
 */
export const formatAddress = (address) => {
    if (!address)
        return '';
    if (address.length <= 10)
        return address;
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
};
/**
 * Gets today's date in YYYY-MM-DD format
 */
export const getTodayDate = () => {
    return format(new Date(), 'yyyy-MM-dd');
};
